import React from "react";
import {
    Link
} from "react-router-dom";
import {
    Alert,
    Table
} from "react-bootstrap";
import PropTypes from "prop-types";

import Loading from "../../components/Loading";
import PriceFormatter from "../../components/priceFormatter";
import ProductTypePill from "../../components/ProductTypePill";

function ProductsTable({ products, error, baseUrl }) {
    return (
        <Table size="sm" className="results" hover={ products && products.length > 0 }>
            <thead className="thead-light">
            <tr>
                <th className="text-center">#</th>
                <th className="text-left">Naam</th>
                <th className="text-left">Prijs</th>
                <th className="text-right">BTW %</th>
                <th className="text-left">Type</th>
                <th className="text-center">Bestelbaar</th>
            </tr>
            </thead>
            <tbody>
            { error ? (
                <tr>
                    <td colSpan={ 6 }>
                        <Alert variant="danger" className="mb-0">{ error }</Alert>
                    </td>
                </tr>
            ) : products === null ? (
                <tr>
                    <td colSpan={ 6 }>
                        <Loading/>
                    </td>
                </tr>
            ) : products.length === 0 ? (
                <tr>
                    <td colSpan={ 6 } className="text-center">
                        <h1><i className="fas fa-shopping-basket"/></h1>
                        <h4>Geen producten</h4>
                        <p>Er staan nog geen producten in de shop.</p>
                    </td>
                </tr>
            ) : products.map((product) => {
                const url = baseUrl + "/product/" + product.id;
                return (
                    <tr key={ product.id } className="table-clickable-row">
                        <th scope="row" className="align-middle text-center">
                            <Link to={ url }>
                                { product.id }
                            </Link>
                        </th>
                        <td className="align-middle">
                            <Link to={ url }>
                                { product.name }
                            </Link>
                        </td>
                        <td className="align-middle">
                            <Link to={ url }>
                                { product.discountPrice !== null ? (
                                    <React.Fragment>
                                        <span style={{textDecoration: "line-through"}} className="text-muted">
                                            <PriceFormatter price={product.price}/>
                                        </span>
                                        {" "}
                                        <PriceFormatter price={product.discountPrice}/>
                                    </React.Fragment>
                                ) : (
                                    <PriceFormatter price={product.price}/>
                                )}
                            </Link>
                        </td>
                        <td className="align-middle text-right">
                            <Link to={ url }>
                                { Math.round(product.taxPercentage * 100) }%
                            </Link>
                        </td>
                        <td className="align-middle">
                            <Link to={ url }>
                                <ProductTypePill product={ product }/>
                            </Link>
                        </td>
                        <td className="align-middle text-center">
                            <Link to={ url }>
                                { product.orderable ? (
                                    <i className="fas fa-check fa-fw text-success"/>
                                ) : (
                                    <i className="fas fa-times fa-fw text-danger"/>
                                )}
                            </Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    );
}
ProductsTable.propTypes = {
    products: PropTypes.array,
    error: PropTypes.string,
    baseUrl: PropTypes.string.isRequired,
};

export default React.memo(ProductsTable);
